import React,{ useState } from 'react'
import { Col } from 'react-bootstrap'
import Card from 'react-bootstrap/Card'
import { Link } from 'react-router-dom'
import { Bar, BarChart, Cell, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts'

import { defaultToEmptyString, svgTextWrap, twoDigits } from '../../../assets/ts/formatting/formatting'
import './charts.css'
import './piecharts.css'

// Function that renders a custom XAxis for the byCategories Chart
const CustomYAxisTick = ({ payload, x, y }: any) => {
    const textArray = svgTextWrap(payload.value, 8)

    return (
      <g transform={`translate(${x},${y})`}>
        <text dy={0} fill='#666' fontSize='11' fontWeight='bold' textAnchor='end' x={0} y={-16}>
          {textArray.map((text) => (
            <tspan dy='1.2em' key={text} x='0'>
              {defaultToEmptyString(text)}
            </tspan>
          ))}
        </text>
      </g>
    )
}
CustomYAxisTick.displayName = 'CustomYAxis'

const CustomXAxisTick = ({ payload, x, y }: any) => {
    return (
      <g transform={`translate(${x},${y})`}>
        <text dx={-5} dy={16} fill='#666' fontSize='11' textAnchor='middle' x={0} y={0}>
          <tspan>{payload.value === 0 ? 
            defaultToEmptyString(payload.value) : 
            defaultToEmptyString(twoDigits(payload.value))}</tspan>
        </text>
      </g>
    )
}
CustomXAxisTick.displayName = 'CustomXAxis'

const ActionPendingChart = (props: any) => {
  const {   
    inquiryCustomer,
    inquiryFilter,
    inquiryPending,
    inquirySourceCSSCount,
    inquirySourceCustomerCount } = props
  const [tooltipActionPending, setTooltipActionPending] = useState({ fill: '#fff', label: '', value: '-' })
  const actionPendingLegend = [
      { fill: '#E6C81D', label: '3 Days' },
      { fill: '#264384', label: '7 Days' },
      { fill: '#5085E5', label: '10 Days' },
      { fill: '#6C56AF', label: 'More than 10 Days' }
  ]
  // eslint-disable-next-line react/no-unstable-nested-components
  const CustomTooltip = ({ active }: any) => {
    if (tooltipActionPending.label === '') return null

    if (active) {
      return (
        <div
          style={{
            backgroundColor: '#fff',
            borderRadius: '5px',
            boxShadow: '0px 0px 5px',
            padding: '0 3px 0 3px'
          }}>
          <h4 style={{ fontSize: '14px' }}>
            {defaultToEmptyString(tooltipActionPending.label)}:{' '}
            <span style={{ color: `${tooltipActionPending.fill}` }}>
              {defaultToEmptyString(twoDigits(tooltipActionPending.value))}
            </span>
          </h4>
        </div>
      )
    }

    return null
  }

  const formattedData: any[] = [{
    name: 'Pending Action Outside CP',
    threeDays: inquiryPending.inquiryPendingThreeDays,
    // eslint-disable-next-line perfectionist/sort-objects
    sevenDays: inquiryPending.inquiryPendingSevenDays,
    tenDays: inquiryPending.inquiryPendingTenDays,
    // eslint-disable-next-line perfectionist/sort-objects
    moreThanTenDays: inquiryPending.inquiryPendingMoreThanTenDays
},
{
    name: 'Customer Action Pending',
    threeDays: inquiryCustomer.inquiryCustomerThreeDays,
    // eslint-disable-next-line perfectionist/sort-objects
    sevenDays: inquiryCustomer.inquiryCustomerSevenDays,
    tenDays: inquiryCustomer.inquiryCustomerTenDays,
    // eslint-disable-next-line perfectionist/sort-objects
    moreThanTenDays: inquiryCustomer.inquiryCustomerMoreThanTenDays
}]



  return (
    <Col className='align-items-stretch w-100-important my-2 d-flex' lg={4} md={6} sm={12}>
      <Card className='w-100'>
        <Card.Body className='d-flex flex-column'>
              <ul
                style={{
                  display: 'flex',
                  margin: '10px 0px 0px auto',
                  paddingLeft: '0'
                }}>
                {actionPendingLegend.map((item) => (
                  <li
                    key={item.label}
                    style={{
                      alignItems: 'center',
                      display: 'flex',
                      listStyle: 'none',
                      marginRight: '15px',
                      textWrap: 'nowrap',
                      width: '100%'
                    }}>
                    <div
                      style={{
                        backgroundColor: item.fill,
                        border: '2px solid #fff',
                        borderRadius: '50%',
                        boxShadow: '0px 0px 3px',
                        height: 10,
                        marginRight: 5,
                        width: 10
                      }}></div>
                    <div aria-label='Label' className='piechartlegend' style={{ color: '#666', fontSize: 11, fontWeight: 'bold' }}>
                      {item.label}
                    </div>
                  </li>
                ))}
              </ul>
              <div style={{ alignItems: 'center', display: 'flex', marginTop: 16 }}>
                <ResponsiveContainer height={300} width='98%'>
                  <BarChart
                    aria-label='Action Pending Chart'
                    className='tooltiphidefocus'
                    data={formattedData}
                    layout='vertical'
                    margin={{ bottom: 0, left: 0, right: 0, top: 0 }}>
                    <Bar
                      dataKey='threeDays'
                      fill='#E6C81D'
                      isAnimationActive={false}
                      layout='vertical'
                      maxBarSize={30}
                      onMouseEnter={(event) =>
                        setTooltipActionPending({
                          fill: '#E6C81D',
                          label: '3 Days',
                          value: event.threeDays
                        })
                      }
                      onMouseLeave={() =>
                        setTooltipActionPending({ fill: '#fff', label: '', value: '-' })
                      }
                      stackId='a'
                      tabIndex={0}
                      viewBox='0 0 100 100'
                    >
                      {formattedData.map((entry) => 
                        <Cell aria-label={entry.name} key={entry.name} />
                        )}
                    </Bar>
                    <Bar
                      dataKey='sevenDays'
                      fill='#264384'
                      isAnimationActive={false}
                      layout='vertical'
                      maxBarSize={30}
                      onMouseEnter={(event) =>
                        setTooltipActionPending({
                          fill: '#264384',
                          label: '7 Days',
                          value: event.sevenDays
                        })
                      }
                      onMouseLeave={() =>
                        setTooltipActionPending({ fill: '#fff', label: '', value: '-' })
                      }
                      stackId='a'
                      tabIndex={0}
                      viewBox='0 0 100 100'
                    >
                      {formattedData.map((entry) => 
                        <Cell aria-label={entry.name} key={entry.name} />
                        )}
                    </Bar>
                    <Bar
                      dataKey='tenDays'
                      fill='#5085E5'
                      isAnimationActive={false}
                      label='10 Days'
                      layout='vertical'
                      maxBarSize={30}
                      onMouseEnter={(event) =>
                        setTooltipActionPending({
                          fill: '#5085E5',
                          label: '10 Days',
                          value: event.tenDays
                        })
                      }
                      onMouseLeave={() =>
                        setTooltipActionPending({ fill: '#fff', label: '', value: '-' })
                      }
                      stackId='a'
                      tabIndex={0}
                      viewBox='0 0 100 100'
                    >
                      {formattedData.map((entry) => 
                        <Cell aria-label={entry.name} key={entry.name} />
                        )}
                    </Bar>
                    <Bar
                      dataKey='moreThanTenDays'
                      fill='#6C56AF'
                      isAnimationActive={false}
                      label='More Than 10 Days'
                      layout='vertical'
                      maxBarSize={30}
                      onMouseEnter={(event) =>
                        setTooltipActionPending({
                          fill: '#6C56AF',
                          label: 'More than 10 Days',
                          value: event.moreThanTenDays
                        })
                      }
                      onMouseLeave={() =>
                        setTooltipActionPending({ fill: '#fff', label: '', value: '-' })
                      }
                      stackId='a'
                      tabIndex={0}
                      viewBox='0 0 100 100'
                    >
                      {formattedData.map((entry) => 
                        <Cell aria-label={entry.name} key={entry.name} />
                        )}
                    </Bar>
                    <XAxis
                      allowDecimals={false}
                      domain={[0, 'auto']}
                      interval='preserveStartEnd'
                      stroke='#eaf0f4'
                      strokeWidth={3}
                      tick={CustomXAxisTick}
                      tickLine={false}
                      type='number'
                      width={20}
                    />
                    <YAxis
                      dataKey='name'
                      height={80}
                      interval={0}
                      stroke='#eaf0f4'
                      strokeWidth={2}
                      tick={CustomYAxisTick}
                      tickLine={false}
                      type='category'
                      width={90}
                    />
                    <Tooltip
                      content={<CustomTooltip />}
                      cursor={{ fill: 'transparent' }}
                      isAnimationActive={false}
                    />
                  </BarChart>
                </ResponsiveContainer>
              </div>
              <div style={{ fontSize: '12px', fontWeight: 'bold', margin: '0 auto' }}>
                <p>{'Inquiries'}</p>
              </div>
        </Card.Body>
      </Card>
    </Col>
  )
}

export default ActionPendingChart